module.exports = __webpack_public_path__ + "static/media/AAC.037db8e3.svg";